import { action } from 'typesafe-actions';
import { stepActionTypes as act } from './stepActionTypes';

export function incrementStep(step) {
  return action(act.INCREMENT, { step });
}

export function decrementStep(step) {
  return action(act.DECREMENT, { step });
}
